<template lang="html">
    <div class="content-wrapper search">

        <section class="content-header">
            <ol class="breadcrumb">
                <li><router-link :to="{name: 'dashboard'}" class="open active"><i class="ti-home"></i></router-link></li>
                <li class="active"><a href="#">{{ getVerbose('search_result_breadcrumb') }}</a></li>
            </ol>
        </section>

        <page-header :pagename="pageName"></page-header>

        <section
            v-loading="loadContent"
            class="content"
        >
            <h2>{{ pageSubtitle }}</h2>

            <div v-if="results && results.length">
                <ul class="search-results-list">
                    <li
                        v-for="result in results"
                        :key="result.title"
                    >
                        <router-link :to="result.to">
                            <img
                                v-if="result.img"
                                :src="result.img"
                                class="result-img"
                            >
                            <h4 v-if="result.title">
                                {{ result.title }}
                            </h4>
                            <h4 v-else>
                                {{ result.name }}
                            </h4>
                            <div
                                v-if="result.description && result.description.length"
                                class="result-description"
                                v-html="result.description"
                            ></div>
                        </router-link>
                    </li>
                </ul>
            </div>
            <span v-else>{{ getVerbose('search_result_no_result') }}</span>

        </section>

    </div>

</template>

<script>
import PageHeader from '../partials/PageHeader.vue';
import {mapGetters} from 'vuex';

export default {
    components: {
        PageHeader
    },
    data() {
        return {
            loadContent: true,
            results: [],
        };
    },
    computed: {
        ...mapGetters('fundation', [
            'getVerbose',
        ]),
        pageName() {
            if(this.loadContent) {
                return this.getVerbose('search_result_loading');
            } else if (this.results.length) {
                if (this.results.length > 1) {
                    return this.results.length + this.getVerbose('search_result_pagename_results');
                }
                else {
                    return this.results.length + this.getVerbose('search_result_pagename_single_result');
                }
            } else {
                return this.getVerbose('search_result_pagename_no_result');
            }
            // changed to a branched if for the 's' of results
            // return this.results.length ? this.results.length + ' results' : 'No result found';
        },
        pageSubtitle() {
            return this.$store.state.searchTerm.length ? this.getVerbose('search_result_subtitle') + this.$store.state.searchTerm : this.getVerbose('search_result_subtitle_empty_request');
        },
    },

    watch: {
        '$store.state.searchTerm': {
            handler (){
                this.search();
            },
            immediate: true,
        },
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit('SET_SEARCHTERM', '');
        next();
    },


    methods: {
        search() {
            this.loadContent = true;
            this.$store.dispatch('getAppFilteredResults', this.$store.state.searchTerm).then((response) => {
                this.$set(this, 'results', response.results);
                this.loadContent = false;
            });

        },
    },
};
</script>

<style lang="scss">
.search {
  padding-top: 65px;
  .result-description{
      overflow: hidden;
      text-overflow: ellipsis;
  }
  .content {
    padding: 15px 45px;
  }
  .search-results-list {
    list-style: none;
    margin: 0;
    padding: 0;
    li {
      border-bottom: 1px solid #ccc;
      &:last-child {
        border-bottom: 0;
      }
    }
    h4 {
      margin-top: 0;
    }
    a {
      display: block;
      padding: 15px 0;
      color: #999;
      transition: color .2s ease-in-out;
      min-height: 100px;
      h4 {
        color: #3c8dbc;
      }
      &:hover {
        color: #333;
        h4 {
          color: #3c8dbc;
        }
      }
    }
    .result-img {
      max-width: 120px;
      max-height: 80px;
      height: auto;
      margin-right: 15px;
      margin-bottom: 5px;
      margin-top: 5px;
      float: left;
      border: 5px solid white;
      box-shadow: 0px 2px 5px 0px rgba(black, .3);
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/search.vue